import { render, staticRenderFns } from "./extra-inventar.vue?vue&type=template&id=379de988&lang=pug&"
import script from "./extra-inventar.vue?vue&type=script&lang=js&"
export * from "./extra-inventar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports